import { all, call, put, takeLatest } from "redux-saga/effects";
import authService from "services/auth.service";
import usersService from "services/users.service";
import { errorUser, setUser, userDisconected } from "./user.action";
import { IUserState, UserActions } from "./user.interface";

function* load(){
  function formatName(text:string){
    let list = text.split(' ');
    let name = "";
    list.forEach((t,i)=>{
      if(i>0) name += " ";
      name += t.substring(0,1).toLocaleUpperCase() + t.substring(1,t.length).toLocaleLowerCase();
    });
    return name;
  }
  try {
    const response:IUserState = yield call(authService.me);
    response.firstname = formatName(response.firstname);
    response.lastname = formatName(response.lastname);
    yield put(setUser(response));
  } catch (error) {
    // localStorage.clear();
    // window.location.reload();
    yield put(errorUser())
  }
}

function* logout(){
  try {
    yield call(authService.logout);
    yield put(userDisconected());
  } catch (error) {}
  yield put(userDisconected());
}

function* setTheme(action:any):any{
  let theme = action.payload.user.theme;
  try {
    yield call(async (props)=>{return await usersService.setSetting(props)},{theme});
  } catch (error) {
    console.error(error);
  }
}

function* setLanguage(action:any):any{
  let language = action.payload.user.language;
  try {
    yield call(async (props)=>{return await usersService.setSetting(props)},{language});
    
  } catch (error) {
    console.error(error);
  }
}

export default function* root():any{
  return yield all([
    takeLatest(UserActions.LOAD_USER, load),
    takeLatest(UserActions.LOGOUT, logout),
    takeLatest(UserActions.SET_THEME, setTheme),
    takeLatest(UserActions.SET_LANGUAGE, setLanguage)
  ]);
}